import { AspectRatio, Box, Flex, Text } from "@chakra-ui/react";
import { DecorativeBackgroundImage } from "components/images";
import { Section } from "components/section";
import React from "react";
import { Button } from "ui/button";
import { ProductShowcaseImage } from "ui/product-showcase";
import { TextTitle } from "ui/text";
import { desktopOnlyDisplay } from "utils";
import bgImage from "../../../../public/assets/platform/ai-decisioning/insights-bg.png";
import productScreen from "../../../../public/assets/platform/ai-decisioning/insights-screen.png";

const dropShadowMd =
  "drop-shadow(0px 34.807px 20.627px rgba(0, 0, 0, 0.02)) drop-shadow(0px 15.47px 15.47px rgba(0, 0, 0, 0.04)) drop-shadow(0px 3.867px 7.735px rgba(0, 0, 0, 0.05))";

export function AidInsights() {
  return (
    <Section id="insights" my={0} scrollMarginTop={32}>
      <Flex
        bg="new.violet.900"
        borderRadius={{ base: "small", md: "bigger" }}
        direction="column"
        pt={{ base: "bigger", md: "huge" }}
        pb={{ base: "bigger", md: "0" }}
        pos="relative"
        overflow="hidden"
      >
        <Box pos="absolute" inset={0}>
          <Box boxSize="100%" pos="relative">
            <DecorativeBackgroundImage src={bgImage} />
          </Box>
        </Box>

        <Box pos="relative" zIndex={1}>
          <TextTitle
            titleAs="h2"
            px="big"
            align="center"
            size="lg"
            maxW="3xl"
            theme="dark"
            chip={{ text: "New feature" }}
            title="Introducing Insights"
            description={
              <Text as="span" color="brand.text.dark">
                Your marketing team’s best learning tool is here. Insights bridges the gap between AI automation and
                human strategy, uncovering new opportunities that make your team smarter and your campaigns stronger.
              </Text>
            }
            actions={
              <Button hasRightChevron href="/blog/introducing-insights">
                Learn about Insights
              </Button>
            }
          />

          <Box display={desktopOnlyDisplay()} mt={{ base: "bigger", xl: "biggest" }} filter={dropShadowMd}>
            <AspectRatio
              ratio={1008 / 355}
              boxSize="100%"
              maxW={{ base: "94%", md: "78%", xl: "920px" }}
              mx="auto"
              pos="relative"
            >
              <ProductShowcaseImage
                src={productScreen}
                alt="UI displaying two selectors on the left and a heat map based on the selected attributes. The attributes selected are 'Messaging' (action breakdown) and 'Age group' (user breakdown). The heatmap shows various conversion rates on a particular message for the given age group."
              />
            </AspectRatio>
          </Box>
        </Box>
      </Flex>
    </Section>
  );
}
